import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { distinctId: String }

  capture(event) {
    const { event: name, ...properties } = event.params
    window.posthog?.capture(name, properties, { transport: 'sendBeacon' })
  }

  identify() {
    window.posthog.identify(this.distinctIdValue)
  }

  reset() {
    window.posthog.reset()
  }
}
